import LegalLayout from "@/components/LegalLayout";
import { COMPANY } from "@/lib/site";

const H = ({ children }) => (
  <h2 className="font-heading font-bold text-xl text-[#1A110B] pt-4">{children}</h2>
);

export default function Terms() {
  return (
    <div data-testid="terms-page">
      <LegalLayout title="Terms & Conditions" updated="June 2026">
        <p>
          These Terms & Conditions ("Terms") govern your use of the {COMPANY.domain} website and
          the IT services provided by {COMPANY.name} ("Beta-Tech Systems," "we," "us," or "our").
          By accessing this website or engaging our services, you agree to these Terms.
        </p>

        <H>1. Services</H>
        <p>
          Beta-Tech Systems provides IT service and support, including the provision, installation,
          and servicing of firewalls, networks, WiFi, telephone systems, surveillance systems, and
          computer and server support for businesses in and around Baton Rouge, Louisiana. Specific
          deliverables, timelines, and pricing are defined in individual quotes or service agreements.
        </p>

        <H>2. Quotes & Payment</H>
        <p>
          Quotes are valid for the period stated and may be subject to change based on site
          conditions or scope adjustments. Payment is due according to the terms specified in your
          invoice or service agreement. Online payments may be made through our secure third-party
          payment provider via the "Make a Payment" link. Late or unpaid balances may result in
          suspension of services.
        </p>

        <H>3. SMS / Text Messaging Program</H>
        <p>
          By providing your mobile phone number and opting in on our contact form, you consent to
          receive SMS text messages from {COMPANY.name} related to appointment reminders, service
          and account updates, and responses to your inquiries. Consent to receive text messages is
          not a condition of purchasing any goods or services.
        </p>
        <p>
          <strong>Message frequency varies.</strong> <strong>Message and data rates may apply.</strong>{" "}
          You may opt out of receiving text messages at any time by replying <strong>STOP</strong> to
          any message; you will receive a confirmation and no further messages unless you opt in
          again. For help, reply <strong>HELP</strong> or contact us at {COMPANY.phone}. Carriers
          (such as AT&amp;T, Verizon, T-Mobile, and others) are not liable for delayed or undelivered
          messages. Mobile opt-in information and consent are never shared with third parties for
          marketing purposes, as described in our Privacy Policy.
        </p>

        <H>4. Client Responsibilities</H>
        <p>
          You agree to provide accurate information, reasonable site access, and any credentials or
          approvals needed for us to perform the work. You are responsible for maintaining
          appropriate backups and for the lawful use of any systems we install or service.
        </p>

        <H>5. Warranties & Limitation of Liability</H>
        <p>
          We perform services with reasonable skill and care. To the fullest extent permitted by
          law, Beta-Tech Systems is not liable for indirect, incidental, or consequential damages,
          including data loss or business interruption. Hardware and software supplied are covered
          by their respective manufacturer or vendor warranties.
        </p>

        <H>6. Third-Party Products & Links</H>
        <p>
          Our services may involve third-party hardware, software, and payment processors. We are
          not responsible for the content, availability, or policies of third-party services linked
          from this website.
        </p>

        <H>7. Intellectual Property</H>
        <p>
          All content on this website, including text, graphics, logos, and the Beta-Tech Systems
          name, is the property of {COMPANY.name} and may not be reproduced without permission.
        </p>

        <H>8. Changes to These Terms</H>
        <p>
          We may update these Terms from time to time. Continued use of our website or services
          after changes are posted constitutes acceptance of the revised Terms.
        </p>

        <H>9. Governing Law</H>
        <p>
          These Terms are governed by the laws of the State of Louisiana, without regard to its
          conflict of law provisions.
        </p>
      </LegalLayout>
    </div>
  );
}
